var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.076285 3.58423C0 3.98854 0 4.47394 0 5.44473V13.2C0 17.3483 0 19.4226 1.28873 20.7112C2.57747 22 4.65164 22 8.8 22H13.2C17.3483 22 19.4226 22 20.7112 20.7112C22 19.4226 22 17.3483 22 13.2V10.7777C22 7.88209 22 6.43429 21.1535 5.49321C21.0758 5.40665 20.9934 5.32426 20.9068 5.24641C19.9657 4.4 18.518 4.4 15.6223 4.4H15.2112C13.9422 4.4 13.3077 4.4 12.7164 4.23146C12.3916 4.13886 12.0784 4.00918 11.7833 3.84497C11.2461 3.54604 10.7974 3.09736 9.90001 2.20001L9.9 2.2L9.29467 1.59473L9.29433 1.59438C8.99382 1.29385 8.8435 1.14352 8.68553 1.01256C8.00417 0.447744 7.16831 0.101519 6.28713 0.019118C6.08274 0 5.87006 0 5.44473 0C4.47394 0 3.98854 0 3.58423 0.076285C1.80434 0.412104 0.412104 1.80434 0.076285 3.58423ZM12.0999 7.97498C11.6443 7.97498 11.2749 8.34434 11.2749 8.79998C11.2749 9.2556 11.6443 9.62498 12.0999 9.62498H17.5999C18.0555 9.62498 18.4249 9.2556 18.4249 8.79998C18.4249 8.34434 18.0555 7.97498 17.5999 7.97498H12.0999Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4842 1.12301C16.3153 1.09998 16.1141 1.09998 15.7119 1.09998H11L11.4069 1.52141C12.1395 2.28026 12.4211 2.56354 12.7465 2.75103C12.9353 2.85987 13.1356 2.94582 13.3434 3.00719C13.7015 3.1129 14.0941 3.11889 15.1301 3.11889H15.4979C16.6005 3.11887 17.4895 3.11886 18.1928 3.21046C18.3682 3.2333 18.5373 3.26238 18.7 3.29998C18.4958 2.15942 17.6047 1.27581 16.4842 1.12301Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderICon);
export default __webpack_public_path__ + "static/media/folderICon.9de2b8ff1cebd97ff733e4a602054434.svg";
export { ForwardRef as ReactComponent };